import React from 'react'
import axios from 'axios'
import htmlTemplateData from './receipt.js'

function fillTemplate(template, data) {
	return template.replace(/{{(.*?)}}/g, (_, key) => data[key.trim()] || '')
}

export default function ReceiptPDF({ data }) {
	const token = localStorage.getItem('token')

	const generatePdf = async () => {
		try {
			const res = await axios.post(
				`${process.env.REACT_APP_API_URL}/receipt/create`,
				{ id: data },
				{ headers: { Authorization: `Bearer ${token}` } },
			)

			let apiData = res.data
			const isApnaMandal = apiData?.paidtoportal
			const purpose = apiData?.purpose?.toLowerCase()

			// let statusText = isApnaMandal
			//   ? "Verified by Apna Mandal"
			//   : "Verified by Sanstha Admin";

			let displayPurpose = apiData?.purpose

			let specialNote = ''

			if (purpose === 'premium membership') {
				displayPurpose = 'Premium Membership Subscription'
				specialNote = 'Thank you for becoming a Premium Member of Apna Mandal!'
			} else if (purpose === 'sponsorship') {
				displayPurpose = 'Event Sponsorship'
				specialNote = 'We sincerely appreciate your generous sponsorship.'
			}

			const receiptData = {
				SANSTHA_LOGO_URL: apiData?.SANSTHA_LOGO_URL || apiData?.image,
				sanstha_name: isApnaMandal ? 'Apna Mandal' : apiData?.sanstha_name,
				sanstha_regno: isApnaMandal ? '' : apiData?.sanstha_regno,
				paymentReciptNo: apiData?.paymentReciptNo || 'N/A',
				date: apiData?.date,
				name: apiData?.name,
				mobile: apiData?.mobile,
				address: apiData?.address || 'N/A',
				email: apiData?.email || 'N/A',
				amount: apiData?.amount,
				mode: apiData?.mode,
				purpose: displayPurpose,
				// status: statusText,
				note: specialNote,
			}
			let filledHtml = fillTemplate(htmlTemplateData, receiptData)
			const printWindow = window.open('', '_blank')
			printWindow.document.open()
			printWindow.document.write(filledHtml)
			printWindow.document.close()

			printWindow.onload = () => {
				setTimeout(() => {
					printWindow.print()
					printWindow.close()
				}, 500)
			}
		} catch (err) {}
	}

	return (
		<>
			<button className="btn btn-sm btn-primary " title=" Download Receipt" onClick={generatePdf}>
				{' '}
				<i className="fa fa-download"></i>
			</button>
		</>
	)
}
